import { FileQuestion } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { usePermissions } from '../../auth/use-permissions'
import { EmptyState } from '../../components/empty-state'
import { defaultRouteFor } from '../../layout/nav-items'

/**
 * The copy here is intentionally free of any hint about why the page is missing.
 *
 * The API answers 404 — not 403 — for a resource that belongs to another tenant,
 * precisely so one customer cannot probe another's fleet structure. Softening
 * this screen into "you may not have access to this vehicle" would hand back the
 * distinction the API worked to remove.
 */
export function NotFoundPage() {
  const { t } = useTranslation()
  const { roles } = usePermissions()

  return (
    <div className="mx-auto max-w-2xl py-10">
      <EmptyState
        icon={FileQuestion}
        title={t('errors:page.notFoundTitle')}
        description={t('errors:page.notFoundDescription')}
        action={
          // A Link, not a Button wrapping one: a nested <a> inside a <button> is
          // invalid markup and loses middle-click and "open in new tab".
          <Link
            to={defaultRouteFor(roles)}
            className="inline-flex h-9 items-center rounded-md border border-border bg-surface px-3.5 text-sm font-medium text-foreground transition-colors hover:bg-surface-hover"
          >
            {t('errors:page.notFoundAction')}
          </Link>
        }
      />
    </div>
  )
}
